<template>
    <div v-if="isVisible">
        <div class="card bg-transparent border-white mt-4" style="border-width: 6px">
            <div class="card-body">
                <div class="mb-n3">
                    <template v-if="course.partners_information">
                        <div class="cursus-content course-page__partners-information mb-3"
                            v-html="course.partners_information"
                        >
                        </div>
                    </template>

                    <template v-if="hasVisuals">
                        <div class="mb-3">
                            <div class="row align-items-center mx-n2">
                                <template v-for="visual in course.partners_visuals">
                                    <div class="col-auto px-2">
                                        <img class="course-page__partners-visual" :src="visual.thumbnail" alt="" @load="handleImageLoaded">
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            course: Object,
        },
        computed: {
            hasVisuals() {
                return !!this.course.partners_visuals?.length;
            },
            isVisible() {
                return this.course.partners_information
                    || this.hasVisuals;
            },
        },
        methods: {
            handleImageLoaded(e) {
                e.target.style.setProperty('--ratio', e.target.naturalHeight / e.target.naturalWidth);
            },
        }
    }
</script>
